/**
 * The sample checkpoints passenger flow is forecast over, the rostered lane
 * plan, and a sample queue sensor.
 *
 * DEMONSTRATION records. Lane counts, rates and targets are PROPOSED figures
 * of the right size for an airport of Madinah's traffic, not the airport's
 * own; the rostered plan is deliberately flat — a fixed number of lanes all
 * day — which is how most rosters are written, so the engine's first job on
 * screen is to show where that plan is too thin and where it is wasted.
 */
import type { Checkpoint, LanePlan, Observation } from "../domain/flow";

export const DOMESTIC_NODES = [
  "RUH", "JED", "DMM", "AHB", "TUU", "GIZ", "TIF", "ELQ", "HAS", "ABT", "YNB", "AJF", "EAM", "BHH", "URY", "WAE",
  "RAE", "TUI", "EJH", "ULH", "DWD", "SHW", "AQI", "KMX",
  /* the ICAO side: every Saudi aerodrome */
  "OE*",
];

export function mockCheckpoints(): Checkpoint[] {
  return [
    { code: "SEC-D", name: "Domestic security", stage: "security", applies: "domestic", lanesMax: 6, ratePerLane: 160, targetWaitMin: 10, staffPerLane: 3, walkMin: 12 },
    { code: "SEC-I", name: "International security", stage: "security", applies: "international", lanesMax: 5, ratePerLane: 140, targetWaitMin: 10, staffPerLane: 3, walkMin: 8 },
    { code: "EMI", name: "Passport control, departures", stage: "emigration", applies: "international", lanesMax: 10, ratePerLane: 110, targetWaitMin: 15, staffPerLane: 1, walkMin: 10 },
    { code: "IMM", name: "Passport control, arrivals", stage: "immigration", applies: "international", lanesMax: 14, ratePerLane: 80, targetWaitMin: 25, staffPerLane: 1, walkMin: 0 },
  ];
}

/** The rostered plan: flat, all day. */
export function mockPlans(now: Date): LanePlan[] {
  const from = new Date(now.getTime() - 6 * 3_600_000).toISOString();
  return [
    { code: "SEC-D", steps: [{ from, lanes: 3 }], by: "Roster (sample)" },
    { code: "SEC-I", steps: [{ from, lanes: 3 }], by: "Roster (sample)" },
    { code: "EMI", steps: [{ from, lanes: 5 }], by: "Roster (sample)" },
    { code: "IMM", steps: [{ from, lanes: 8 }], by: "Roster (sample)" },
  ];
}

/** A sample sensor over domestic security, counting more than the model expected. */
export function mockObservations(now: Date, predictedQueue: number): Observation[] {
  return [
    {
      code: "SEC-D",
      at: new Date(now.getTime() - 4 * 60_000).toISOString(),
      queue: Math.max(12, Math.round(predictedQueue * 1.35 + 8)),
      source: "sensor",
    },
  ];
}
